import React, { PropTypes } from 'react';
import cn from 'classnames';
import { DefaultButton } from '@bibliocommons/base-buttons';
import { childrenShape } from '@bibliocommons/bc-prop-types';
import { Angle } from '@bibliocommons/base-icons';

import './ReviewButton.scss';

export default function ReviewButton({ title, action, handleClick, className }) {
  return (
    <DefaultButton handleClick={handleClick} className={cn('cp-review-button', className)}>
      <div className="title">{title}</div>
      <div className="action">
        {action}
        &nbsp;
        <Angle.Right />
      </div>
    </DefaultButton>
  );
}

ReviewButton.propTypes = {
  handleClick: PropTypes.func,
  title: childrenShape,
  action: childrenShape,
  className: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/ReviewButton/ReviewButton.jsx